import moment from 'moment';
import {
    TIMEREGISTRATIONLIST_PAGE,
    TIMEREGISTRATIONLIST_SEARCH,
    TIMEREGISTRATIONLIST_USER,
    TIMEREGISTRATIONLIST_WEEK,
    TIMEREGISTRATIONLIST_YEAR
} from '../actions/timeregistrationlistactions';

const state = {
    search: '',
    page: 0,
    userId: -1,
    year: moment().format('YYYY'),
    week: moment(new Date(), "MMDDYYYY").isoWeek()
};

const getters = {
    page: state => state.page,
    search: state => state.search,
    userId: state => state.userId,
    year: state => state.year,
    week: state => state.week,
};

const actions = {
    [TIMEREGISTRATIONLIST_SEARCH]: ({ commit }, search) => {
        commit(TIMEREGISTRATIONLIST_SEARCH, search);
    },
    [TIMEREGISTRATIONLIST_PAGE]: ({ commit }, page) => {
        commit(TIMEREGISTRATIONLIST_PAGE, page);
    },
    [TIMEREGISTRATIONLIST_USER]: ({ commit }, userId) => {
        commit(TIMEREGISTRATIONLIST_USER, userId);
    },
    [TIMEREGISTRATIONLIST_YEAR]: ({ commit }, year) => {
        commit(TIMEREGISTRATIONLIST_YEAR, year);
    },
    [TIMEREGISTRATIONLIST_WEEK]: ({ commit }, week) => {
        commit(TIMEREGISTRATIONLIST_WEEK, week);
    },
};

const mutations = {
    [TIMEREGISTRATIONLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [TIMEREGISTRATIONLIST_PAGE]: (state, page) => {
        state.page = page;
    },
    [TIMEREGISTRATIONLIST_USER]: (state, userId) => {
        state.page = 0;
        state.userId = userId;
    },
    [TIMEREGISTRATIONLIST_YEAR]: (state, year) => {
        state.page = 0;
        state.year = year;
    },
    [TIMEREGISTRATIONLIST_WEEK]: (state, week) => {
        state.page = 0;
        state.week = week;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};